import type {SegmentedControlProps as MantineSegmentedControlProps} from '@mantine/core';
import {SegmentedControl as MantineSegmentedControl} from '@mantine/core';

export type SegmentedControlProps = MantineSegmentedControlProps;

/**
 * Segmented option toggle — design-layer pass-through over Mantine `SegmentedControl`.
 * @registry Pass-through Mantine SegmentedControl; import this instead of @mantine/core outside src/design.
 */
export const SegmentedControl = MantineSegmentedControl;
